import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context";
import { FullscreenMobileLayout } from "../fullscreen-mobile-layout/fullscreen-mobile-layout";
import { FloatingDesktopLayout } from "./floating-desktop-layout";
const FloatingLayout = (props) => {
  const { isMobile } = useContext(RicosContext);
  const Layout = isMobile ? FullscreenMobileLayout : FloatingDesktopLayout;
  return /* @__PURE__ */ React.createElement(Layout, { ...props });
};
export {
  FloatingLayout
};
//# sourceMappingURL=floating-layout.js.map
